import Box, { BoxProps } from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import { FC } from 'react'

type FullPageLoaderProps = {
  containerBoxProps?: BoxProps
}

/**
 * Simple loading component that is intended for display in the main content
 * section of the app when waiting for route data to load.
 * @returns
 */
const FullPageLoader: FC<FullPageLoaderProps> = ({ containerBoxProps }) => {
  return (
    <Box
      {...containerBoxProps}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        width: '100%',
        // 209px here is the sum of the the fixed Angular topbar height, bottom border, bottom margin, and page header
        height: 'calc(100vh - 209px)',
        ...containerBoxProps?.sx,
      }}
    >
      <Box sx={{ width: '50%' }}>
        <LinearProgress />
      </Box>
    </Box>
  )
}

export default FullPageLoader
